var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useMemo } from 'react';
export var useStatusMenuItems = function (unavailableCodes, changeAgentStatus, endSession) {
    return useMemo(function () { return __spreadArray(__spreadArray([
        {
            key: 'available',
            label: 'Available',
            onClick: function () { return changeAgentStatus('available'); }
        },
        {
            key: 'unavailable',
            label: 'Unavailable',
            onClick: function () { return changeAgentStatus('unavailable'); }
        }
    ], unavailableCodes.map(function (code) { return ({
        key: code.reason,
        label: code.reason,
        onClick: function () { return changeAgentStatus('unavailable', code.reason); }
    }); }), true), [
        { type: 'divider' },
        {
            key: 'stopSession',
            label: 'Stop Session',
            onClick: endSession
        }
    ], false); }, [unavailableCodes, changeAgentStatus, endSession]);
};
